exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/login.theprintlife.com/src/app/mnt-master/announcement-detail/announcement-detail.component.css
// module id = ../../../../../src/app/mnt-master/announcement-detail/announcement-detail.component.css
// module chunks = main